import { render, staticRenderFns } from "./vendor-scope-set-modal.vue?vue&type=template&id=377a05cb&"
import script from "./vendor-scope-set-modal.vue?vue&type=script&lang=js&"
export * from "./vendor-scope-set-modal.vue?vue&type=script&lang=js&"
import style0 from "./vendor-scope-set-modal.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "vendor-scope-set-modal.vue"
export default component.exports